module.exports = __webpack_public_path__ + "media/landing_page/flexibility-a1c442fb.webp";